export default {
  text: 'Denne restaurant er suspenderet. Kontakt din kontaktperson, eller skriv til os på <a>{{supportEmail}}</a>, hvis du ønsker at genoprette den',
};
